import { CallToAction } from "./call-to-action/src/call-to-action";
import { CustomerTestimonials } from "./customer-testimonials/src/customer-testimonials";
import { FeaturesHighlight } from "./features-highlight/src/features-highlight";
import { Hero } from "./hero/src/hero";
import { HeroCarousel } from "./hero-carousel/src/hero-carousel";
import { Integration } from "./integration/src/integration";
import { Logos } from "./logos/src/logos";
import { MobileApp } from "./mobile-app/src/mobile-app";
import { SideNav } from "./side-nav/src/side-nav";
import { Stats } from "./stats/src/stats";
import { TabsSection } from "./tabs/src/";

export { CallToAction };
export { CustomerTestimonials };
export { Hero };
export { HeroCarousel };
export { Stats };
export { TabsSection };
export { Logos };
export { FeaturesHighlight };
export { Integration };
export { MobileApp };
export { SideNav };
